import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { Builder } from 'lunr';
import Papa from 'papaparse';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function LoadFile(props) {
  const [getLunrBuilder, setLunrBuilder] = React.useState();
  const [getStatus, setStatus] = React.useState();

  let IndexByTime = {};
  let IndexByProcess = {};
  let IndexByLevel = {};
  let IndexByStream = {};
  let IndexByErrorType = {};
  let IndexActivity = {};

  if (!getLunrBuilder) {
    let builder = new Builder();
    builder.ref('id');
    builder.field('ActivityId');
    builder.field('ErrorCode');
    builder.field('ErrorCodeMsg');
    builder.field('ErrorType');
    builder.field('File');
    builder.field('Function');
    builder.field('Instance');
    builder.field('Level');
    builder.field('Line');
    builder.field('MDRESULT');
    builder.field('Message');
    builder.field('Pid');
    builder.field('Stream');
    builder.field('Tid');
    builder.field('TimeStamp');
    builder.field('traceparentId');
    builder.field('Date');
    builder.field('Time');

    setLunrBuilder(builder);
  }

  const IndexByTwoLevels = (l0, pos, k1, k2) => {
    let l1 = l0[k1];
    if (!l1) {
      l0[k1] = {};
      l1 = l0[k1];
    }

    if (!l1.meta) {
      l1.meta = {};
    }

    let l2 = l1[k2];
    if (!l2) {
      l1[k2] = [];
      l2 = l1[k2];
    }

    if (!l2.meta) {
      l2.meta = {};
    }

    l2.push(pos);
  }

  const clickIncludeLunr = (e) => {
    props.setIncludeLunr(props.getIncludeLunr ? false : true);
  }

  const BuildIndex = (pos, record) => {
    record.id = pos;

    record.TimeStamp = record["[0] Time Stamp"];

    if (record.TimeStamp.length > 0) {
      let dt = new Date(record.TimeStamp);
  
      let yyyy = dt.getUTCFullYear().toString();
      let MM = (dt.getUTCMonth() + 1) < 10 ? "0" + (dt.getUTCMonth() + 1) : (dt.getUTCMonth() + 1).toString();
      let dd = dt.getUTCDate() < 10 ? "0" + dt.getUTCDate() : dt.getUTCDate().toString();
      record.Date = yyyy + "-" + MM + "-" + dd;
  
      let hh = dt.getUTCHours() < 10 ? "0" + dt.getUTCHours() : dt.getUTCHours().toString();
      let mm = dt.getUTCMinutes() < 10 ? "0" + dt.getUTCMinutes() : dt.getUTCMinutes().toString();
      let ss = dt.getUTCSeconds() < 10 ? "0" + dt.getUTCSeconds() : dt.getUTCSeconds().toString();
      record.Time = hh + ":" + mm + ":" + ss;

      let shortTS = MM + "/" + dd + " " + hh + ":" + mm + ":" + ss;
      //let hourlyTS = MM + "/" + dd + " " + hh + ":00:00";
      let DayTS = yyyy + "-" + MM + "-" + dd;

      // *********************
  
      IndexByTwoLevels(IndexByTime, pos, record.Date, hh + ":00:00");
      IndexByTwoLevels(IndexByProcess, pos, record.Pid, DayTS);
      IndexByTwoLevels(IndexByLevel, pos, "Level " + record.Level, DayTS)
      IndexByTwoLevels(IndexByStream, pos, record.Stream, DayTS)
      IndexByTwoLevels(IndexByErrorType, pos, record.ErrorType, DayTS);
      IndexByTwoLevels(IndexActivity, pos, record.ActivityId, "All");

      let text = "Monitoring Agent Version ";
      let n = record.Message.indexOf(text);
      if (n >= 0) {
        n += text.length;
        let ver = record.Message.substr(n, 8);
        IndexByProcess[record.Pid].meta.Version = ver;
      }

      let metaTimeStamp = IndexByProcess[record.Pid].meta;
      if (!metaTimeStamp.FirstTS || metaTimeStamp.FirstTS > shortTS)
      {
        metaTimeStamp.FirstTS = shortTS;
      }
      if(record.Stream === "MonAgentCore.exe")
      {
        metaTimeStamp.Agent = "Core";
      }
      else if(record.Stream === "MonAgentManager.exe")
      {
        metaTimeStamp.Agent = "AgentMgr";
      }
      else if(record.Stream === "MetricsExtension")
      {
        metaTimeStamp.Agent = "ME";
      }
      else if(record.Stream === "IFxBroadcast")
      {
        metaTimeStamp.Agent = "IFx";
      }

      text = "Agent will exit when parent process ";
      n = record.Message.indexOf(text);
      if (n === 0)
      {
        n = text.length;
        let m = record.Message.indexOf(" exits.");
        let pid = record.Message.substr(n, m-n);
        metaTimeStamp.Parent = pid;
      }
  
      // *********************

      if (props.getIncludeLunr) {
        getLunrBuilder.add(record);
      }
    }
    else
    {
      console.log("Bad Record:", record);
    }
  }

  const buildLunrIndex = (e) => {
    // Finalize Index

    let lunrIdx = getLunrBuilder.build();

    populateMetaLevel(e.records, IndexByTime);
    //populateMetaLevel(e.records, IndexByProcess);

    // *******************

    let msg = "Done building index";
    setStatus(msg);
    console.log(msg);

    if (props.onUpdateIndex) {
      let index = {
        File: e.file,
        Records: e.records,
        LunrIndex: lunrIdx,
        Index: [
          {
            Name: "Date x Time",
            Index: IndexByTime,
          },
          {
            Name: "Process",
            Index: IndexByProcess,
          },
          {
            Name: "Level",
            Index: IndexByLevel,
          },
          {
            Name: "Stream",
            Index: IndexByStream,
          },
          {
            Name: "ErrorType",
            Index: IndexByErrorType,
          },
          {
            // The prefix "-" hides it from display
            Name: "-Activity",
            Index: IndexActivity,
          }
        ]
      }

      props.onUpdateIndex(index);
    }

    return true;
  }

  const addLunrIndex = (e) => {
    let file = e.file;
    let prom = e.prom;
    let records = e.records;
    let pos = e.pos;

    let endPos = Math.min(pos + 20000, records.length);

    let msg = "Indexing: " + endPos + " of " + records.length;
    setStatus(msg);
    console.log(msg, e);

    while (pos < endPos) {
      BuildIndex(pos, records[pos]);
      pos++;
    }

    if (pos < records.length) {
      prom.then(() => {
        return new Promise((resolve) => {
          setTimeout(() => {
            let r = addLunrIndex({
              file: file,
              prom: prom,
              records: records,
              pos: pos,
            });
            resolve(r);
          }, 10);
        });
      });
    }
    else {
      let msg = "Building index...";
      setStatus(msg);
      console.log(msg, e);

      prom.then(() => {
        return new Promise((resolve) => {
          setTimeout(() => {
            let r = buildLunrIndex({
              file: file,
              prom: prom,
              records: records,
              pos: pos,
            });
            resolve(r);
          }, 10);
        });
      });
    }

    return { prom: prom, records: records, pos: pos };
  }

  const populateMetaLevel = (records, l1) => {
    for (let n in l1) {
      if (n === "meta") {
        continue;
      }

      let l2 = l1[n];

      let le1 = 0;
      let le2 = 0;
      let le3 = 0;
      let le4 = 0;
      let le5 = 0;

      for (let m in l2) {
        let recs = l2[m];

        let e1 = 0;
        let e2 = 0;
        let e3 = 0;
        let e4 = 0;
        let e5 = 0;

        for (let q in recs) {
          if (q === "meta") {
            continue;
          }

          let id = recs[q];

          switch (records[id].Level) {
            case "1":
              e1++;
              break;
            case "2":
              e2++;
              break;
            case "3":
              e3++;
              break;
            case "4":
              e4++;
              break;
            default:
              e5++;
              break;
          }
        }

        if (e1 > 0) {
          recs.meta.e1 = e1;
        }
        if (e2 > 0) {
          recs.meta.e2 = e2;
        }
        if (e3 > 0) {
          recs.meta.e3 = e3;
        }
        if (e4 > 0) {
          recs.meta.e4 = e4;
        }
        if (e5 > 0) {
          recs.meta.e5 = e5;
        }

        le1+= e1;
        le2+= e2;
        le3+= e3;
        le4+= e4;
        le5+= e5;
      }

      if (le1 > 0) {
        l2.meta.e1 = le1;
      }
      if (le2 > 0) {
        l2.meta.e2 = le2;
      }
      if (le3 > 0) {
        l2.meta.e3 = le3;
      }
      if (le4 > 0) {
        l2.meta.e4 = le4;
      }
      if (le5 > 0) {
        l2.meta.e5 = le5;
      }
    }
  }

  const onChange = (e) => {
    let file = e.target.files[0];
    if (file) {
      setStatus("Reading file...");

      let promResolve;

      const prom = new Promise((resolve) => {
        promResolve = resolve;
      });

      prom.then((data) => {
        return new Promise((resolve) => {
          setTimeout(() => {
            let r = addLunrIndex({
              file: file,
              prom: prom,
              records: data,
              pos: 0,
            });
            resolve(r);
          }, 10);
        });
      });

      Papa.parse(file, {
        header: true,
        quoteChar: '"',
        complete: (results) => {
          setStatus("Start indexing...");
          console.log("Records", results.data.length, results.data[0], results.data[results.data.length - 1]);
          promResolve(results.data);
        }
      });
    }
  }

  let items = [];

  const onFileClick = (e) => {
    let file = document.getElementById('file');
    file.click();
  }

  if (!getStatus) {
    items.push(
      <div key={items.length}>
        <button type="button" className="btn btn-primary" onClick={onFileClick}>Open MAEventTable.csv</button>
        <input id="file" type="file" style={{ display: "none" }} onChange={onChange} accept=".csv" />
      </div>
    );
    items.push(
      <div key={items.length}>
        Lunr Search: {props.getIncludeLunr ? <Badge bg="info" onClick={clickIncludeLunr}>On</Badge> : <Badge bg="secondary" onClick={clickIncludeLunr}>Off</Badge>}
      </div>
    )
  }
  else {
    items.push(
      <h2 key={items.length}>{getStatus}</h2>
    );
  }

  return (
    <div>
      {items}
    </div>
  );
}

export default LoadFile;
